import React from "react";

export const ClearIcon = (props) => {
  return (
    <>
      <svg
        width={19}
        height={19}
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <circle
          cx={9.5}
          cy={9.5}
          r={9}
          fill="#888888"
          stroke="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: 1,
            stroke: "#888888",
            stroke: "color(display-p3 0.5333 0.5333 0.5333)",
            strokeOpacity: 1,
          }}
        />
        <path
          d="M6.07812 13.3291L13.3281 6.0791L6.07812 13.3291Z"
          fill="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M6.07812 13.3291L13.3281 6.0791"
          stroke="white"
          style={{
            stroke: "white",
            strokeOpacity: 1,
          }}
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
        <path
          d="M6.16193 5.99971L13.2497 13.4084L6.16193 5.99971Z"
          fill="#888888"
          style={{
            fill: "#888888",
            fill: "color(display-p3 0.5333 0.5333 0.5333)",
            fillOpacity: 1,
          }}
        />
        <path
          d="M6.16193 5.99971L13.2497 13.4084"
          stroke="white"
          style={{
            stroke: "white",
            strokeOpacity: 1,
          }}
          strokeWidth={2}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
      </svg>
    </>
  );
};
